module.exports = __webpack_public_path__ + "static/media/HCMM424.a02245d5.jpg";